// What the Keyboard shortcuts sheet lists (SI-5, SIGNED_IN_PLAN 3.6):
// every key the web binds and nothing else (no ⌘1 to ⌘9, ⌘N, ⌘O or ⌘,),
// grouped as the app's keyboard_shortcuts_sheet.dart groups its table: the
// menu keys by menu (Edit, View, Help), then the keys a list or a deck
// takes while it is on screen. Labels follow the app's where it has the
// key; the web's own (⌘F, Discover's deck) name what they do.
//   shortcutGroups({ mac })  [{ header, rows: [{ label, keys: [...] }] }]
export function shortcutGroups({ mac = false } = {}) {
  const mod = mac ? "⌘" : "Ctrl";
  const enter = mac ? "Return" : "Enter";
  return [
    {
      header: "Edit",
      rows: [
        { label: "Search…", keys: [mod, "K"] },
        { label: "Find in this list", keys: [mod, "F"] },
      ],
    },
    {
      header: "View",
      rows: [
        { label: "Hide sidebar", keys: mac ? ["⌃", "⌘", "S"] : ["Ctrl", "Alt", "S"] },
        { label: "Close a sheet or menu", keys: ["Esc"] },
      ],
    },
    { header: "Help", rows: [{ label: "Keyboard shortcuts", keys: ["?"] }] },
    {
      header: "Session list",
      rows: [
        { label: "Previous or next session in the list", keys: ["↑", "↓"] },
        { label: "Open the highlighted session", keys: [enter] },
        { label: "Switch session tabs (phone width)", keys: ["←", "→"] },
      ],
    },
    {
      header: "Discover",
      rows: [
        { label: "Pass", keys: ["←"] },
        { label: "Like", keys: ["→"] },
        { label: "Hop in", keys: [enter] },
        { label: "Undo", keys: [mod, "Z"] },
        { label: "Pause or play", keys: ["Space"] },
        { label: "Back to your sessions", keys: ["Esc"] },
      ],
    },
    {
      header: "Sounds, packs and My audio",
      rows: [
        { label: "Previous or next sound", keys: ["↑", "↓"] },
        { label: "Play or pause", keys: ["Space"] },
      ],
    },
  ];
}

export default shortcutGroups;
